<template>
    <div class="404">
        <h1>Error 404</h1>
        <v-img
                alt="Neocity Logo"
                class="shrink mr-2 col-2"
                contain
                src="@/assets/images/neocity-logo.png"
                transition="scale-transition"
                height="35"
        />
        <v-btn to="/system/dashboard">volver</v-btn>
    </div>
</template>
<script>
    export default {
        name: '404',
    }
</script>